import { Heading, Image, Paragraph, Text } from '@rover/kibble/core';

import DoodleImage from './images/DoodleTestA.png';

const TestAContent = (): JSX.Element => (
  <>
    <Image height="144px" width="100%" resizeMethod="center" description="sds" src={DoodleImage} />
    <Heading size="300">Sitter updates + smart insights</Heading>
    <Paragraph size="200">
      Get the full picture of your pet's day with this offer from our partner Tractive: Get a{' '}
      <Text size="200" fontWeight="semibold">
        free pet GPS & activity tracker
      </Text>{' '}
      with purchase of a subscription. Don't wait—only a limited number of Rover pet parents can
      redeem this offer!
    </Paragraph>
  </>
);

export default TestAContent;
